<template>
  <div class="tips-wrapper">
    <div class="content">
      <img class="arrow" :src="require('@/assets/img/arrow_wx.png')" />
      <div class="row">点击右上角的按钮</div>
      <div class="row">选择<img class="btn-tips" :src="require('@/assets/img/browser_tips.png')"/></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.tips-wrapper {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .7);

  .content {
    position: relative;
    top: 30vw;
    left: 10vw;
    width: 90vw;
    color: #fff;
    font-size: 5vw;

    .row {
      display: flex;
      align-items: center;
      margin-bottom: 5vw;
    }
  }

  .arrow {
    position: absolute;
    top: -20vw;
    right: 10vw;
    width: 26vw;
    height: 26vw;
  }

  .btn-tips {
    margin-left: 5vw;
    width: 63.7vw;
    height: 10.4vw;
  }
}
</style>
